<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-conditions [show]="true" [ShowSecondDownloadExcel]="false" [ShowSecondExport]="true" [ShowBuyer]="true" [ShowVendor]="true" [QueryFromParent]="onQueryClick()" [ShowUpload]="false"  (listenForm)="getFormValue($event)" ></app-wmsm-conditions>
    </div>
  <nz-card>

    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格" >
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px"   nzSize="middle" nzShowSizeChanger
      [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'  [nzScroll]="{ y: '600px',x:'1600px' }">
      <thead>
        <tr>
          <th scope="col" nzWidth="150px"  [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{ "table.PONO" | translate}}</th>
          <th scope="col" >{{ "table.POLN" | translate}}</th>
          <th scope="col" >{{ "table.ChangedField" | translate}}</th>
          <th scope="col" >{{ "table.ChangedContent" | translate}}</th>
          <th scope="col" >{{ "table.ChangedBy" | translate}}</th>
          <th scope="col" >{{ "table.ChangedDate" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of colSpanTable.data;let i=index">
          <td >{{data.pono}}</td>
          <td >{{data.poln}}</td>
          <td >{{data.changeField}}</td>
          <td >{{data.changeContentAfter}}</td>
          <td >{{data.changeOwner}}</td>
          <td >{{data.changeDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
        </tr>
      </tbody>
    </nz-table>
    <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'" nzShowSizeChanger
    [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)" [nzPageSizeOptions]="[10, 20, 50,100]"
   (nzPageIndexChange)="nzPageIndexChange($event)" [nzItemRender]="renderItemTemplate"></nz-pagination>
   
   <ng-template #renderItemTemplate let-type let-page="page">

     <a *ngIf="type === 'page'">{{ page }}</a>
     <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
     <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
   </ng-template>
    </div>
  </nz-card>
  </div>
</nz-spin>
